import { statusMapper } from 'src/utils/statusMapper';

type StatusMapperProps = {
  status: string;
  statusPhaseOneLabel: string;
  statusPhaseOneText: string;
  statusPhaseTwoLabel: string;
  statusPhaseTwoText: string;
  statusPhaseThreeLabel: string;
  statusPhaseThreeText: string;
};

export const setCongestionStatus = ({
  status,
  statusPhaseOneLabel,
  statusPhaseOneText,
  statusPhaseTwoLabel,
  statusPhaseTwoText,
  statusPhaseThreeLabel,
  statusPhaseThreeText,
}: StatusMapperProps) => {
  return statusMapper<'Afgerond' | 'Voltooid' | 'Lopend'>({
    currentStatus: status ?? 'Lopend',
    variants: [
      {
        status: 'Lopend',
        label: statusPhaseOneLabel?.toString() ?? '',
        text: statusPhaseOneText?.toString() ?? '',
      },
      {
        status: 'Afgerond',
        label: statusPhaseTwoLabel?.toString() ?? '',
        text: statusPhaseTwoText?.toString() ?? '',
      },
      {
        status: 'Opgelost',
        label: statusPhaseThreeLabel?.toString() ?? '',
        text: statusPhaseThreeText?.toString() ?? '',
      },
    ],
    fallback: {
      status: 'Lopend',
      label: statusPhaseOneLabel?.toString() ?? '',
      text: statusPhaseOneText?.toString() ?? '',
    },
  });
};
